import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  designations: [],
  loading: false,
  error: null,
  filters: {
    search: '',
    department: 'all',
    status: 'all',
  },
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
  stats: {
    total: 0,
    active: 0,
  },
};

const designationSlice = createSlice({
  name: 'designation',
  initialState,
  reducers: {
    setDesignations: (state, action) => {
      state.designations = action.payload.data || [];
      state.pagination = {
        ...state.pagination,
        totalPages: action.payload.totalPages || 1,
        totalItems: action.payload.totalItems || 0,
        currentPage: action.payload.currentPage || 1,
      };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      state.pagination.currentPage = 1; // Reset to first page when filters change
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setStats: (state, action) => {
      state.stats = action.payload;
    },
    clearFilters: (state) => {
      state.filters = initialState.filters;
      state.pagination.currentPage = 1;
    },
  },
});

export const {
  setDesignations,
  setLoading,
  setError,
  setFilters,
  setPagination,
  setStats,
  clearFilters,
} = designationSlice.actions;

export default designationSlice.reducer;
